module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.data) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "24px",
      "margin-top": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    }
  }, _vm._l((_vm.data.days), function(day, dayIndex) {
    return (_vm.data.availableDays.includes(day.name)) ? _c('mu-float-button', {
      key: 'day-' + dayIndex,
      staticClass: "day-button",
      class: {
        'activeDay': day.name === _vm.activeDay
      },
      staticStyle: {
        "margin": "2px"
      },
      attrs: {
        "mini": "",
        "label": "M"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setDay(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [(_vm.data) ? _c('h1', [_vm._v(_vm._s(_vm.data.name))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "24px"
    }
  }, [_vm._v(_vm._s(_vm.data.availableDays.length) + " day meal plan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [(_vm.readonly) ? _c('mu-raised-button', {
    attrs: {
      "icon": "delete",
      "label": "Delete"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteMealPlan.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Create a new meal plan based of this one.'),
      expression: "'Create a new meal plan based of this one.'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "icon": _vm.readonly ? 'save_alt' : 'cancel',
      "label": _vm.readonly ? 'Create from' : 'Cancel'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleReadonly.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (!_vm.readonly) ? _c('mu-raised-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Save as new meal'),
      expression: "'Save as new meal'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "primary": "",
      "icon": "check",
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openModal.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), (_vm.data.availableMeals.includes('BREAKFAST')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "breakfast",
      "recipe": _vm.activeBreakfastForDay
    },
    on: {
      "changed": _vm.pushToBreakfast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.availableMeals.includes('LUNCH')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "lunch",
      "recipe": _vm.activeLunchForDay
    },
    on: {
      "changed": _vm.pushToLunch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.availableMeals.includes('DINNER')) ? _c('meal-plan-panel', {
    attrs: {
      "readonly": _vm.readonly,
      "activeDay": _vm.activeDay,
      "type": "dinner",
      "recipe": _vm.activeDinnerForDay
    },
    on: {
      "changed": _vm.pushToDinner
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "title": "Give your meal plan a name"
    },
    on: {
      "close": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlan.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    attrs: {
      "full-width": "",
      "label": "Name",
      "hint-text": "Enter a name for your meal plan"
    },
    model: {
      value: (_vm.custom.name),
      callback: function($$v) {
        _vm.$set(_vm.custom, "name", $$v)
      },
      expression: "custom.name"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "type": "button",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlan.apply(null, arguments)
      }
    },
    slot: "actions"
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c894b2f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/MealPlanDetail.vue
// module id = 3595
// module chunks = 1